import {ActivatedRouteSnapshot, CanActivate, CanMatch, Route, Router, UrlSegment} from '@angular/router';
import {inject, Injectable} from '@angular/core';
import {CurrentUserStore} from '../services/user/store/current-user.store';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate, CanMatch {
  private router = inject(Router);
  private currentUserStore = inject(CurrentUserStore);

  canActivate(route: ActivatedRouteSnapshot) {
    const allowedRoles = route.data['roles'] as string[] | undefined;
    return this.checkAuth(allowedRoles);
  }

  canMatch(route: Route, _segments: UrlSegment[]) {
    const allowedRoles = route.data?.['roles'] as string[] | undefined;
    return this.checkAuth(allowedRoles);
  }

  private checkAuth(allowedRoles?: string[]) {
    if (!this.currentUserStore.authenticated()) {
      return this.router.createUrlTree(['/auth/login']);
    }

    if (allowedRoles?.length && !this.currentUserStore.hasAnyRole(allowedRoles)) {
      return this.router.createUrlTree(['/forbidden']);
    }

    return true;
  }
}
